import React, { useEffect } from 'react'

import 'react-multi-carousel/lib/styles.css'

import { Dropdown } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { StickyNotesWrapper } from './StickyNotesWrapper'
import AppLayout from '../common/AppLayout'
import AppTitle from '../common/AppTitle'
import { useAuth } from '../common/Auth'
import emitter from '../service/emitter'
import { Package } from '../types/gopay'

function DashboardPage() {
    const auth = useAuth()
    const navigate = useNavigate()
    const {t} = useTranslation()

    useEffect(() => {
        if (auth.user?.selectedPackage === Package.EXPIRED) {
            navigate('/app/edit-profile#invoices')
        }
    }, [auth.user, navigate])

    return (
        <AppLayout>
            <AppTitle append={
                <Dropdown className={'ms-2 amani-primary'}>
                    <Dropdown.Toggle variant="success" className="amani-primary" id="dropdown-add-note">
                        {t('add')} &nbsp;
                    </Dropdown.Toggle>

                    <Dropdown.Menu>
                        <Dropdown.Item
                            onClick={() => {
                                emitter.emit('add-sticky-note')
                            }}>
                            {t('note_label')}
                        </Dropdown.Item>
                        <Dropdown.Item
                            onClick={() => {
                                emitter.emit('add-sticky-todo')
                            }}>
                            {t('todo_label')}
                        </Dropdown.Item>
                    </Dropdown.Menu>
                </Dropdown>
            }>{t('Dashboard')}</AppTitle>

            <div className="row">
                <div className="col-md-12">
                    <StickyNotesWrapper/>
                </div>
            </div>
        </AppLayout>
    )
}

export default DashboardPage
